function Titlebar ({title}) {
    return (
        <div className="bg-rakete shadow">
                <div className="text-center rakete-font fw-semibold text-white text-uppercase py-3">{title}</div>
        </div>
    )
}

export default Titlebar;